// src/store/vendorFieldsStore.ts
import { create } from 'zustand';

export interface VendorFieldConfig {
  name: string;
  label: string;
  required: boolean;
  type?: 'text' | 'email' | 'select' | 'textarea'; // Optional for future expansion
}

interface VendorFieldsState {
  fields: VendorFieldConfig[];
  isLoaded: boolean;
  setFields: (fields: VendorFieldConfig[]) => void;
  reset: () => void;
}

export const useVendorFieldsStore = create<VendorFieldsState>((set) => ({
  fields: [],
  isLoaded: false,
  setFields: (fields) => set({ fields, isLoaded: true }),
  reset: () => set({ fields: [], isLoaded: false }),
}));
